import React, { useEffect } from "react";

import SelectCompany from "../components/Selectcompany/SelectCompany";
import i18n from "../i18n/config";

const SelectCompanyPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("documentTitle", { ns: "selectCompany" })}`;
  }, []);

  return <SelectCompany />;
};

export default SelectCompanyPage;
